import useCapabilities, { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";

/** Capability check for person Events routes. Denied users are redirected by `events/_layout`. */
export function usePersonEventsAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonEvents = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonEvents
  });

  return {
    loaded,
    canViewPersonEvents
  };
}
